module.exports = __webpack_public_path__ + "img/Nasike-Judith.bea981b0.jpeg";